import { SkeletonBox, SkeletonText, SkeletonCircle } from '../primitives';
import '../primitives/Skeletons.css';

const NavBarSkeleton = () => (
  <div className="skeleton-navbar">
    <SkeletonCircle size={32} />
    <SkeletonText widths={['100px']} lineHeight="20px" />
  </div>
);

const TodaySkeleton = () => {
  return (
    <div aria-hidden="true">
      <NavBarSkeleton />
      <div className="skeleton-today">
        {/* Hero section */}
        <div className="skeleton-today__hero">
          <SkeletonText widths={['180px']} lineHeight="32px" />
          <SkeletonText widths={['250px']} lineHeight="16px" style={{ marginTop: 'var(--space-sm)' }} />

          {/* Metrics badges */}
          <div className="skeleton-today__metrics">
            <SkeletonBox width={100} height={36} borderRadius="var(--radius-pill)" />
            <SkeletonBox width={120} height={36} borderRadius="var(--radius-pill)" />
            <SkeletonBox width={90} height={36} borderRadius="var(--radius-pill)" />
          </div>
        </div>

        {/* Topic list */}
        <div className="skeleton-today__list">
          {[1, 2, 3, 4, 5, 6].map((item) => (
            <div key={item} className="skeleton-today__item">
              <SkeletonCircle size={40} />
              <div style={{ flex: 1 }}>
                <SkeletonText widths={[`${100 + (item % 3) * 30}px`]} lineHeight="18px" />
                <SkeletonText widths={['80px']} lineHeight="14px" style={{ marginTop: '4px' }} />
              </div>
              <SkeletonBox width={60} height={32} borderRadius="var(--radius-sm)" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TodaySkeleton;
